import React, {useState} from 'react';
import Calendar, {CalendarTileProperties, ViewCallbackProperties} from 'react-calendar';
import TimeButton from '../timeButton/timeButton';
import {useMeetingAppDispatch, useMeetingAppState} from '../eventSlotSelectionApp.store';
import {getIsoFormat} from './dayTimeSelector.pure';

/**
 * Component for selecting a day on a given startDate of a month
 * @param startDate
 * @constructor
 */
const DayTimeSelector: React.FC<MeetingSelectorProps> = ({startDate}) => {
  const meetingDispatch = useMeetingAppDispatch();
  const {meeting, selectedDay, displayedMonth} = useMeetingAppState();
  const [showTimeArea, setShowTimeArea] = useState(false);

  const timeButtons = [];

  const monthChanged = ({activeStartDate}: ViewCallbackProperties) => {
    meetingDispatch({
      type: 'ON_SELECT_MONTH',
      payload: activeStartDate
    });
  };

  const dayClicked = (data: Date | Date[]) => {
    setShowTimeArea(true);

    const selectedDate = Array.isArray(data) ? data[0] : data;
    meetingDispatch({
      type: 'ON_SELECT_DAY',
      payload: selectedDate
    });
  };

  const occurrences = meeting?.occurrences ?? [];

  let formattedDate = '';

  if (selectedDay) {
    const options = {weekday: 'long', month: 'long', day: 'numeric'};

    // @ts-ignore
    formattedDate = selectedDay.toLocaleDateString('de-DE', options);

    const indexOfSelectedDay = getIsoFormat(selectedDay);
    for (const occurrence of occurrences) {
      if (indexOfSelectedDay === getIsoFormat(new Date(occurrence.from))) {
        timeButtons.push(<TimeButton key={occurrence.from} occurrence={occurrence} />);
      }
    }
  }

  const isTileDisabled = ({date}: CalendarTileProperties): boolean => {
    if (date < new Date()) {
      return true;
    }

    const index = getIsoFormat(date);

    const available_occurrences = occurrences.filter(function (occurrence) {
      return getIsoFormat(new Date(occurrence.from)) == index && occurrence.is_available;
    });

    return available_occurrences.length === 0;
  };

  const getTileClass = ({date}: CalendarTileProperties): string => {
    const index = getIsoFormat(date);
    const matchingOccurrence = occurrences.find(
      (occurrence) => getIsoFormat(new Date(occurrence.from)) === index
    );

    if (matchingOccurrence && matchingOccurrence.is_available === false) {
      return 'was-bookable';
    }

    return '';
  };

  return (
    <>
      {!showTimeArea ? (
        <Calendar
          className={'w-100'}
          onClickDay={dayClicked}
          onActiveStartDateChange={monthChanged}
          value={selectedDay}
          tileDisabled={isTileDisabled}
          tileClassName={getTileClass}
          showNeighboringMonth={false}
          prev2Label={null}
          next2Label={null}
          maxDetail={'month'}
          minDetail={'month'}
          activeStartDate={displayedMonth ?? startDate}
        />
      ) : (
        <>
          <div className={'react-calendar w-100'}>
            <div className={'react-calendar__navigation'}>
              <button
                type={'button'}
                className={'react-calendar__navigation__arrow'}
                onClick={() => setShowTimeArea(false)}
              >
                ‹
              </button>

              <button
                type={'button'}
                className={'react-calendar__navigation__label flex-grow-1'}
                disabled
              >
                <span className="react-calendar__navigation__label__labelText react-calendar__navigation__label__labelText--from">
                  {formattedDate}
                </span>
              </button>

              <button type={'button'} className={'react-calendar__navigation__arrow'} disabled />
            </div>
          </div>

          <div className={'time-slot-picker'}>
            <div className={'time-slot-list overflow-hidden p-1'}>{timeButtons}</div>
          </div>
        </>
      )}
    </>
  );
};
export default DayTimeSelector;
